import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ApplicationService {

  public applicationType: string;

  constructor() { }

  public setApplicationType(type: string): void {
    this.applicationType = type;
  }
}
